module.exports = __webpack_public_path__ + "img/modelo-pr1.ee1736eb.png";